import dayjs from "dayjs"

/** Prefer last activity; fall back to legacy fields on session rows. */
export function getSessionTimestamp(session: {
  last_active?: number | string
  updated_at?: number | string
  created_at?: number | string
}): number | string | undefined {
  return session.last_active ?? session.updated_at ?? session.created_at
}

function parseSessionInstant(ts: number | string): dayjs.Dayjs {
  if (typeof ts === "number") {
    const ms = ts < 1e12 ? ts * 1000 : ts
    return dayjs.utc(ms).local()
  }
  return dayjs.utc(ts).local()
}

/** Messages tab + Home recent card: today shows clock time, else relative. */
export function formatSessionListTime(
  ts: number | string | undefined | null
): string {
  if (ts == null || ts === "") return "Just now"
  const day = parseSessionInstant(ts)
  if (!day.isValid()) return "Just now"
  return day.isSame(dayjs(), "day") ? day.format("h:mm A") : day.fromNow(true)
}
